<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.001"><g style="opacity:.4"><path d="m100 54.53 2.472 5.266 5.527.844-4 4.1.944 5.788L100 67.8l-4.944 2.733L96 64.74l-4-4.1 5.527-.844z" style="stroke:none;fill:none" transform="translate(-92 -54.527)" fill="currentColor"/><path d="m100 56.883-1.794 3.821-4.131.631 2.993 3.068-.694 4.254 3.625-2.004 3.626 2.004-.694-4.254 2.993-3.068-4.131-.63-1.794-3.822m0-2.353 2.472 5.266 5.528.845-4 4.1.944 5.788L100 67.796l-4.944 2.733L96 64.74l-4-4.1 5.527-.844L100 54.53z" style="fill:#333;stroke:none" transform="translate(-92 -54.527)" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-favor-off',
});
</script>
